export default __webpack_public_path__ + "static/media/21.1b545b7d.jpg";